import { render, staticRenderFns } from "./companyListItem.vue?vue&type=template&id=4a3a4873&scoped=true"
import script from "./companyListItem.vue?vue&type=script&lang=js"
export * from "./companyListItem.vue?vue&type=script&lang=js"
import style0 from "./companyListItem.vue?vue&type=style&index=0&id=4a3a4873&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3a4873",
  null
  
)

export default component.exports